// ========== URLS & LINKS ==========
export const URLS = {
  CALENDLY: "https://calendly.com/ovation-team/meet-bravo",
  PRIVACY_POLICY: "https://ovationventures.com/privacy-policy",
  TERMS: "https://ovationventures.com/terms-of-use",
  WEALTH_MANAGERS: "/wealthmanagers",
  CREDIT_UNIONS: "/creditunions",
  EMPLOYERS: "/employers",
} as const;

// ========== TRACKING ==========
export const TRACKING = {
  GA_ID: "G-MHJS13NJRR",
} as const;

export const PAGE_NAMES: Record<string, string> = {
  [URLS.WEALTH_MANAGERS]: "bravo_wealth_managers",
  [URLS.CREDIT_UNIONS]: "bravo_credit_unions",
  [URLS.EMPLOYERS]: "bravo_employers",
} as const;

// ========== ASSET PATHS ==========
export const ASSETS = {
  BRAND: {
    LOGO: "/logo.png",
    FAVICON: "/favicon.png",
    OG_IMAGE: "/og-image.png",
  },
  HOW_IT_WORKS: {
    BRAND: "/hw-brand.png",
    CONFIGURE: "/hw-configure.png",
    DEPLOY: "/hw-deploy.png",
    GROW: "/hw-grow.png",
  },
  UTILITIES: {
    ELLIPSE_GLOW: "/ellipse-glow.png",
    ARROW_RIGHT: "/arrow-right.png",
  },
} as const;
